import { Component, OnInit } from '@angular/core';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { PublicacaoConfig, DirecaoPublicacao } from '../../../../types/smartinteg';
import { ConfirmationService } from 'primeng/api';
import { ConfigService } from '../../../../config/config.service';

@Component({
  selector: 'app-publicacao-list',
  templateUrl: './publicacao-list.component.html',
  styleUrls: ['./publicacao-list.component.css'],
  providers: [ConfirmationService]
})
export class PublicacaoListComponent implements OnInit {

  publicacoes: PublicacaoConfig[] = [];
  loading: boolean = true;
  apiUrl: string;

  constructor(
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private configService: ConfigService
  ) {
    this.apiUrl = this.configService.getApiUrl();
  }

  ngOnInit(): void {
    this.carregarPublicacoes();
  }

  carregarPublicacoes(): void {
    this.loading = true;
    this.smartintegService.listarPublicacoes().subscribe({
      next: (data) => {
        this.publicacoes = data;
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao carregar publicações.');
        this.loading = false;
      }
    });
  }

  deletarPublicacao(publicacao: PublicacaoConfig): void {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja deletar a publicação <strong>${publicacao.nome}</strong>?`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Lógica de deleção
      }
    });
  }

  getMetodoHttp(direcao: DirecaoPublicacao): string {
    return direcao === DirecaoPublicacao.INBOUND ? 'POST' : 'GET';
  }

  getDirecaoSeverity(direcao: DirecaoPublicacao): string {
    return direcao === DirecaoPublicacao.INBOUND ? 'warning' : 'info';
  }

  copyUrl(url: string): void {
    navigator.clipboard.writeText(url);
    this.toastService.sucesso('Copiado', 'URL copiada para a área de transferência.');
  }
}
